<template>
  <div>
    <label :class="error ? '' : ''">{{ label }}
      <a-tooltip v-if="tooltip" placement="right">
        <template #title>
          <span>{{ tooltip }}</span>
        </template>
        <i class="mdi mdi-information"/>
      </a-tooltip>
    </label>
    <div class="input-group">
      <a-input addonBefore="€" @input="onSubmit" type="number" step="0.01"
               :value="data" :name="id" class="form-control" :disabled="disabled" />
      <div v-if="error" class="invalid-feedback error-text">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'input-money',
  props: ['id', 'label', 'data', 'error', 'tooltip', 'disabled'],
  data () {
    return {
      errors: false
    }
  },
  methods: {
    ...mapActions('survey', ['submit', 'validate']),
    onSubmit (e) {
      this.submit({ name: this.id, value: e.target.value })
    }
  }
}
</script>
